<template lang="pug">
  v-container#list.pr-0(fluid)
    v-flex(xs12)
      v-card(flat)
        v-card-text.pb-0.small Busca palabras:
        v-card-title.py-0.searchbar
          v-text-field.px-3.search(
            v-model="search"
            append-icon="search"
            placeholder="Filtra los folios por palabra clave"
            hide-details
            class="input-group--focused"
          )
          v-card-actions(v-if="currentUser.permission.createReports")
            v-btn.add(
              fab
              dark
              @click="setCreateForm"
              )
              v-icon(dark) add
                //to="/form"
        v-data-table.mt-4(
          :headers="headers"
          :items="reportsForTable"
          :search="search"
          :pagination.sync="pagination"
          expand
        )
          template(
            slot="items"
            slot-scope="props"
          )
            tr(ref="tr" @click="setRecord(props.item)")
              td.bold.px-1 {{ props.item.folio }}
              td.text-xs-left.gray-text.px-1 {{ props.item["aggressionDate"] }}
              td.text-xs-left.px-1 {{ props.item.state }}
              td.text-xs-left.px-1 {{ props.item.sexualIdentity}}
          v-alert(
            slot="no-results"
            :value="true"
            color="error"
            icon="warning"
          ) No se encontraron resultados.
</template>
<script>
export default {
  name: "List",
  props: {},
  data() {
    return {
      user: this.$store.state.user,
      search: "",
      pagination: {
        rowsPerPage: 15
      },
      headers: [
        {
          text: "Folio",
          align: "left",
          value: "folio"
        },
        { text: "Fecha del hecho", value: "aggressionDate" },
        { text: "Estado", value: "state" },
        { text: "Identidad de género / orientación sexual", value: "sexualIdentity" }
      ]
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.user;
    },
    reports() {
      return this.$store.getters.reports;
    },
    reportsForTable() {
      let reports = this.reports;
      return reports;
    }
  },
  methods: {
    setCreateForm: async function () {
      this.$store.commit("setEditionState", false);
      this.$store.commit("resetRecord");
      await this.$nextTick();
      this.$router.push('/form')
    },
    setRecord(record) {
      // console.log(record)
      //this.$refs.tr.classList.toggle('selected')
      if (this.user.role === "Administración" || record.public === true) {
        this.$store.commit("setRecord", record);
      }
    },
    getReports() {
      this.$store.dispatch("getReports");
    },
    getOptions() {
      this.$store.dispatch("getOptions");
    }
  },
  mounted() {
    this.getReports();
    this.getOptions();
    if (this.reports.length > 0)
      this.setRecord(this.reports[0]);
  }
};
</script>
<style src="./list.scss" lang="scss">
</style>
